import React from "react"

import {
  CheckBoxInput,
  RadioButtonInput,
  SelectorInputProps,
} from "@axtesys/kassen-app-ui"

type BaseSpacedSelectorInputProps = Omit<SelectorInputProps, "spaceBetween">
type ExtendedSpacedSelectorInputProps = BaseSpacedSelectorInputProps & {
  width: number
}

export {
  BaseSpacedSelectorInputProps,
  ExtendedSpacedSelectorInputProps,
  SpacedCheckBoxInput,
  SpacedRadioButtonInput,
}

function SpacedRadioButtonInput({
  style,
  width,
  ...props
}: ExtendedSpacedSelectorInputProps) {
  return <RadioButtonInput {...props} spaceBetween style={[{ width }, style]} />
}

function SpacedCheckBoxInput({
  style,
  width,
  ...props
}: ExtendedSpacedSelectorInputProps) {
  return <CheckBoxInput {...props} spaceBetween style={[{ width }, style]} />
}
